var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerifiedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0.00170898C4.98578 0.00170898 0.5 4.48749 0.5 10.0017C0.5 15.5159 4.98578 20.0017 10.5 20.0017C16.0142 20.0017 20.5 15.5159 20.5 10.0017C20.5 4.48749 16.0142 0.00170898 10.5 0.00170898ZM15.5684 7.88257L10.1516 13.2991C9.98914 13.4616 9.77582 13.5434 9.5625 13.5434C9.34918 13.5434 9.13586 13.4616 8.97336 13.2991L6.26508 10.5909C5.93915 10.2651 5.93915 9.73834 6.26508 9.41257C6.59085 9.08664 7.11743 9.08664 7.44336 9.41257L9.5625 11.5317L14.3901 6.70428C14.7159 6.37836 15.2424 6.37836 15.5684 6.70428C15.8941 7.03006 15.8941 7.55664 15.5684 7.88257Z",
    fill: "#0BDA51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedIcon);
export default __webpack_public_path__ + "static/media/verifiedIcon.b1cd1d723ffe12bb397b40074168fa34.svg";
export { ForwardRef as ReactComponent };